/*
 * A wrapper containing spending widgets. One for last month's spending,
 * and one for this month's spending.
 * 
 * This is intended for use in the reseller dashboard, and in the reseller budget tab
 */
import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import AbEnvironment from '../auth/AbEnvironment'; 
import withStyles from '@mui/styles/withStyles';
import { Button, Grid, Typography } from '@mui/material';
import TextWidget from '../ui/TextWidget';
import LinearProgressWidget from '../ui/LinearProgressWidget';
import CreditCard from '@mui/icons-material/CreditCard';
import AppBindStyles from '../../AppBindStyles';

const abEnvironment = new AbEnvironment();
const SpendingWidgetsQuery = graphql`
query SpendingWidgetsQuery($accountId: UUID!) {
  getaccountspendingthismonth2(accountid: $accountId) {
    spentLastMonth
    spentThisMonth
    budget
  }
}
`;

const styleSheet = theme => ({
  root: {
      width: '100%',
  },
  buttonicon: {
    marginRight: 6,
  },
  instructButton: {
    marginTop: -1,
  },
  widgetContainer: {
    // marginTop: 8,
    //marginBottom: 8,
  }
});
  
/*
 * Props coming in:
 * - narrow      (use narrower tiles)
 * - accountId   (for lookup)
 * - spendLimit  (monthly spend limit)
 */
class SpendingWidgets extends Component {
    
  goTo(route, theTab) {
    if (theTab != null) {
      localStorage.setItem('psInOut', theTab);
    }
    this.props.history.push(`/${route}`);
  }

  render() {
    const classes = this.props.classes;

    return (
      <QueryRenderer
        environment={abEnvironment.getEnvironment()}
        query={SpendingWidgetsQuery}
        variables={{accountId: this.props.accountId}}
        render={({error, props})=> {

          if (error) {
            return <div>{error.message}</div>
          } else if (props) {
            let slm = props.getaccountspendingthismonth2.spentLastMonth;
            let spentLastMonth = Number(slm).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});

            let stm = props.getaccountspendingthismonth2.spentThisMonth;
            let spentThisMonth = Number(stm).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});

            let spendLimitText = null;
            let spendLimit = this.props.spendLimit;
            if (spendLimit != null && spendLimit !== '') {
              spendLimitText = Number(spendLimit).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
            }

            // There are 3 use cases we are supporting:
            // 1. Reseller looking at own account (on My funding)
            // 2. Customer looking at own account (on My funding)
            // 3. Reseller looking at customer account
            //
            // Depending on which case it is, there will be different verbiage in the various chicklets
            //
            let lastMonthDescription = "Last month's spending";
            let lastMonthTt = "This is the amount you spent on subscriptions last month.";
            let thisMonthDescription = "This month's spending";
            let thisMonthTt = "This is the amount you've spent on subscriptions this month.";

            if (abEnvironment.getUserAttribute("a_aType") === "4") {
              // Set the customer messages
            } else if (this.props.accountId !== abEnvironment.getUserAttribute("a_id")) {
              // Set the reseller view customer messages
              lastMonthTt = "This is the amount your customer spent on subscriptions last month.";
              thisMonthTt = "This is the amount your customer has spent on subscriptions this month.";
            }

            return (
              <Grid container spacing={3} justifyContent="flex-start" className={classes.widgetContainer}>
                <Grid item>
                  {spendLimit == null &&
                  <TextWidget
                    narrow={this.props.narrow}
                    value={spentLastMonth}
                    description={lastMonthDescription}
                    tooltip={lastMonthTt}
                  />}
                  {spendLimit != null &&
                  <LinearProgressWidget
                    narrow={this.props.narrow}
                    nominator={slm}
                    denominator={spendLimit}
                    description={lastMonthDescription}
                    tooltip={lastMonthTt}
                  />}
                </Grid>
                <Grid item>
                  {spendLimit == null &&
                  <TextWidget
                    narrow={this.props.narrow}
                    value={spentThisMonth}
                    description={thisMonthDescription}
                    tooltip={thisMonthTt}
                  />}
                  {spendLimit != null &&
                  <LinearProgressWidget
                    narrow={this.props.narrow}
                    nominator={stm}
                    denominator={spendLimit}
                    description={thisMonthDescription}
                    tooltip={thisMonthTt}
                  />}
                </Grid>
                {this.props.showEditLink &&
                <Grid item xs={12}>
                  <Typography variant="body2" style={{lineHeight:"2"}}>
                    {spendLimitText == null &&
                    <React.Fragment>
                      <span>You haven't set a monthly spend limit in</span>&nbsp;&nbsp;
                    </React.Fragment>}
                    {spendLimitText != null &&
                    <React.Fragment>
                      <span>You set a monthly spend limit of</span>&nbsp;
                      <span style={AppBindStyles.boldLabel}>{spendLimitText}</span>&nbsp;
                      <span>in</span>&nbsp;&nbsp;
                    </React.Fragment>}

                    <Button color="primary" 
                            size="small" 
                            variant="outlined" 
                            className={classes.instructButton}
                            onClick={() => this.goTo('fundingsources', 1)}
                    >
                      <CreditCard className={classes.buttonicon}/> My Funding
                    </Button> 
                  </Typography>
                </Grid>}
              </Grid>
            );
          }            
        }}
      />
    );
  }
}

export default withStyles(styleSheet)(SpendingWidgets);